import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'
import { useFacesheetCard } from '#src/components/patient/detail-content/facesheet/FacesheetCardContext.ts'

export type FacesheetCardLabelProps = ComponentPropsWithoutRef<'h5'>

// The section name. Carries the card's label id so its bare-triangle collapse
// trigger can name itself after the section. Semibold rather than bold as part
// of de-emphasizing the label cluster.
export function FacesheetCardLabel({
  className,
  ...delegated
}: FacesheetCardLabelProps): JSX.Element {
  const { labelId } = useFacesheetCard()

  return (
    <h5
      id={labelId}
      className={cn('font-semibold', className)}
      {...delegated}
    />
  )
}
